/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ServeImageRequest = {
  /**
   * The ID of the asset to serve
   */
  id: string;
};

export type ServeImageResponse = {
  headers: { [k: string]: Array<string> };
  result: ReadableStream<Uint8Array>;
};

/** @internal */
export type ServeImageRequest$Outbound = {
  id: string;
};

/** @internal */
export const ServeImageRequest$outboundSchema: z.ZodMiniType<
  ServeImageRequest$Outbound,
  ServeImageRequest
> = z.object({
  id: z.string(),
});

export function serveImageRequestToJSON(
  serveImageRequest: ServeImageRequest,
): string {
  return JSON.stringify(
    ServeImageRequest$outboundSchema.parse(serveImageRequest),
  );
}

/** @internal */
export const ServeImageResponse$inboundSchema: z.ZodMiniType<
  ServeImageResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
    Result: z.custom<ReadableStream<Uint8Array>>(x =>
      x instanceof ReadableStream
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
      "Result": "result",
    });
  }),
);

export function serveImageResponseFromJSON(
  jsonString: string,
): SafeParseResult<ServeImageResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ServeImageResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ServeImageResponse' from JSON`,
  );
}
